import React from 'react';
import { normalizeCardPlayer, tierOf } from './cardUtils.js';
import useFitText from './useFitText.js';

function NovaStarMini() {
  return (
    <svg className="pcard-mini__star-svg" viewBox="0 0 24 24" aria-hidden="true">
      <circle className="pcard-mini__star-glow" cx="12" cy="12" r="7.5" />
      <path d="M12 2.2 13.9 10.1 21.8 12 13.9 13.9 12 21.8 10.1 13.9 2.2 12 10.1 10.1Z" />
      <circle className="pcard-mini__star-core" cx="12" cy="12" r="1.5" />
    </svg>
  );
}

export default function PlayerCardMini({ player, showRating = true, className = '', emptySlot = false }) {
  const cardPlayer = normalizeCardPlayer(player);
  const tier = tierOf(cardPlayer.overall);
  const visualTier = tier || 'bronze';
  const classes = [
    'pcard-mini',
    `pcard-mini--${visualTier}`,
    !tier && 'pcard-mini--unrated',
    className,
  ].filter(Boolean).join(' ');
  const hasRating = showRating && cardPlayer.rating !== null;
  const nameRef = useFitText(emptySlot ? '' : cardPlayer.name);

  if (emptySlot) {
    return (
      <article
        className={['pcard-mini', 'pcard-mini--empty', className].filter(Boolean).join(' ')}
        aria-label={cardPlayer.positionLabel ? `Empty ${cardPlayer.positionLabel} slot` : 'Empty slot'}
      >
        <div className="pcard-mini__face">
          <div className="pcard-mini__top pcard-mini__top--position-only">
            <span className="pcard-mini__position">{cardPlayer.positionLabel || '-'}</span>
          </div>
          <div className="pcard-mini__star">
            <NovaStarMini />
          </div>
          <div className="pcard-mini__name" />
          <strong className="pcard-mini__overall">-</strong>
        </div>
      </article>
    );
  }

  return (
    <article className={classes} aria-label={`${cardPlayer.name || 'Unrated'} mini player card`}>
      <div className="pcard-mini__face">
        <div className={`pcard-mini__top${hasRating ? '' : ' pcard-mini__top--position-only'}`}>
          {hasRating && (
            <div className="pcard-mini__rating">
              <strong className="pcard-mini__rating-value">{cardPlayer.rating.toFixed(1)}</strong>
              <span className="pcard-mini__rating-label">RATING</span>
            </div>
          )}
          <span className="pcard-mini__position">{cardPlayer.positionLabel || '-'}</span>
        </div>

        <div className="pcard-mini__star">
          <NovaStarMini />
        </div>

        <div className="pcard-mini__name" title={cardPlayer.name || undefined}>
          <span ref={nameRef} className="pcard-mini__name-text">{cardPlayer.name || '-'}</span>
        </div>

        <strong className="pcard-mini__overall">{cardPlayer.overall ?? '-'}</strong>
      </div>
    </article>
  );
}
